import { Quote } from "lucide-react";
import amanPhoto from "@/assets/aman-sajid.png";

export const DomainWarmupFounderQuote = () => {
  return (
    <div className="relative overflow-hidden">
      {/* Premium gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-foreground via-foreground/95 to-primary/90 rounded-2xl" />
      
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary/20 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-primary/10 rounded-full blur-2xl" />
      
      <div className="relative z-10 p-6 sm:p-8 md:p-10">
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center md:items-start">
          {/* Photo */}
          <div className="shrink-0">
            <div className="relative">
              <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-2xl overflow-hidden ring-4 ring-primary/30 shadow-2xl">
                <img 
                  src={amanPhoto} 
                  alt="Aman Sajid - Founder of IT Dukes"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Decorative quote icon */}
              <div className="absolute -bottom-2 -right-2 w-10 h-10 bg-primary rounded-xl flex items-center justify-center shadow-lg">
                <Quote className="w-5 h-5 text-primary-foreground" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center md:text-left">
            <blockquote className="font-display text-lg sm:text-xl md:text-2xl text-primary-foreground leading-relaxed mb-5">
              "I've seen companies lose months of progress by skipping warmup. 
              One client tried to send 5,000 emails on day one with a new domain—their 
              inbox rate dropped to 12%. After a proper 6-week warmup, they consistently 
              hit 94%. The extra time investment pays for itself many times over."
            </blockquote>

            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
              <div>
                <div className="font-display font-semibold text-primary-foreground text-lg">
                  Aman Sajid
                </div>
                <div className="text-sm text-primary-foreground/70">
                  Founder, IT Dukes
                </div>
              </div>
              <div className="hidden sm:block w-px h-8 bg-primary-foreground/20" />
              <div className="text-xs text-primary-foreground/60 max-w-xs">
                Helping businesses optimize their email infrastructure and deliverability
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
